import React from "react";

export default function Header() {
  return (
    <div className="container">
      <table
        align="center"
        border="0"
        cellpadding="0"
        cellspacing="0"
        width="857"
      >
        <tr>
          <td>
            <img
              src="https://d3as0cp6fyip55.cloudfront.net/images/spacer.gif"
              width="397"
              height="1"
              border="0"
              alt=""
            />
          </td>
          <td>
            <img
              src="https://d3as0cp6fyip55.cloudfront.net/images/spacer.gif"
              width="460"
              height="1"
              border="0"
              alt=""
            />
          </td>
          <td>
            <img
              src="https://d3as0cp6fyip55.cloudfront.net/images/spacer.gif"
              width="1"
              height="1"
              border="0"
              alt=""
            />
          </td>
        </tr>

        <tr>
          <td>
            <img
              name="tnb_r1_c1"
              src="https://d3as0cp6fyip55.cloudfront.net/images/tnb_r1_c1.jpg"
              width="397"
              height="146"
              border="0"
              alt=""
            />
          </td>
          <td>
            <img
              name="tnb_r1_c2"
              src="https://d3as0cp6fyip55.cloudfront.net/images/tnb_r1_c2.jpg"
              width="460"
              height="146"
              border="0"
              alt=""
            />
          </td>
          <td>
            <img
              src="https://d3as0cp6fyip55.cloudfront.net/images/spacer.gif"
              width="1"
              height="146"
              border="0"
              alt=""
            />
          </td>
        </tr>
      </table>
    </div>
  );
}
